export default {
    data() {
        return {
            // 总条数
            total: 0,
            // 每页显示条数
            pageSize: 15,
            // 当前页
            currentPage: 1,
            // 日志数据
            logs: [],
            // 用户
            user: {
                name: '',
                idcard: '',
                company: ''
            }
        }
    },

    methods: {
        // 获取数据
        getData() {
            let name = this.user.name
            let idcard = this.user.idcard
            let company = this.user.company
            this.$post('user_log/search', {
                shop_id: this.$store.state.store.id,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                name: name,
                idcard: idcard,
                company: company,
            }).then(res => {
                if (res.status === 200) {
                    this.logs = res.data.result.data
                    this.total = res.data.result.total
                }
            })
        },

        // 搜索
        confirmSearch() {
            //   console.log(this.user)
            this.currentPage = 1
            let name = this.user.name
            let idcard = this.user.idcard
            let company = this.user.company
            this.$post('user_log/search', {
                shop_id: this.$store.state.store.id,
                name: name,
                idcard: idcard,
                company: company,
                offset: 0,
                length: this.pageSize
            }).then(res => {
                if (res.status === 200) {
                    this.logs = res.data.result.data
                    this.total = res.data.result.total
                }
            })
        },

        // 每页显示条数发生变化时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.getData()
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.getData()
        }
    },
    created() {
        // 获取数据
        this.getData()
    },
}